import React from 'react';
import "./Header.css"
const Header = () => {
    return (
        <div className=" my-3">
            <div className="header_top d-flex justify-content-between  container">
                <div className="logo">
                    
                    <span className="air">Air</span>
                    <span className="time">Ticket </span>
                    
                </div>
                <div className="search_bar mt-3">
                    <div class="input-group input-group-sm">
                        <input type="text" class="form-control" placeholder="Search item" aria-label="Recipient's username" aria-describedby="button-addon2" />
                        <button class ="btn btn-outline-secondary" type ="button" id="button-addon2">Search</button>
                    </div>
                </div>
                <div className="login mt-3">
                    <img src="https://www.bdstall.com/asset/static-image/cart-icon.jpg" className="img-fluid " alt="" />
                    <button className="btn-outline-warning btn-sm">Login</button>
                </div>
            </div>
            <div className="text-center">
            <h5>Air Ticket Price in Bangladesh | Domestic & International Fare</h5>
            <h6>Total Budget $ 500 Million </h6>
            </div>
            
            <nav class="navbar navbar-expand-md navbar-light bg-light ">
                <div class="container-fluid">
                    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
                        <span class="navbar-toggler-icon"></span>
                    </button>
                    <div class="collapse navbar-collapse container" id="navbarNavDropdown">
                        <ul class="navbar-nav ms-auto ">
                            <li class="nav-item">
                                <a class="nav-link active" aria-current="page" href="/">Home</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/">Features</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" href="/">Pricing</a>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Header;